import { FETCH_STARTUP_APPLICATION } from '../../constants/actionConstants';

const initialState = {
    startupData: []
};

export default (state = initialState, action) => {

    let newState;
    switch (action.type) {

        case FETCH_STARTUP_APPLICATION:
            newState = {
                ...state,
                startupData: action.payload
            };
            return newState;
        default:
            return state;
    }
}
